import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import withMessage from '../../withMessage.jsx';
import { composeType, SystemMessageIcon } from '../../utils/systemMessage.jsx';
import { createMessage } from '../../messageHelpers.js';

// eslint-disable-next-line object-curly-newline
const SystemMessage = props => {
  const { subtype, onScrollDown, messageTime, renderText } = props;
  const messageChild = useRef(null);

  useEffect(() => {
    if (subtype === 'file') {
      const img = messageChild.current.querySelector('img'); // there is no way to get it

      if (img) {
        img.onload = () => {
          onScrollDown();
          img.onload = null;
        };
      }
    }
  });

  return (
    <div className={composeType(subtype)}>
      <div className="message-text" ref={messageChild}>

        {<SystemMessageIcon subtype={subtype} />}
        {messageTime}
        {renderText ? renderText('span') : createMessage(props).renderText('span')}
      </div>
    </div>
  );
};

if (process.env.NODE_ENV !== 'production') {
  SystemMessage.propTypes = {
    onScrollDown: PropTypes.func.isRequired,
    messageTime: PropTypes.node,
    subtype: PropTypes.string,
    text: PropTypes.string,
    renderText: PropTypes.func,
  };
}

export default withMessage(SystemMessage);
